<mat-card [ngClass]="{'draftPreview': !editing}" class="draft-card" [formGroup]="formGroup">
    <mat-card-actions class="draft-actions">
        <div class="draft-title">
            {{model.subject ? model.subject : "New message"}}
        </div>
        <div class="draft-buttons">
	    <mat-checkbox *ngIf="editing" formControlName="useHTML" (change)="htmlToggled()" id="useHTML" matTooltip="Use HTML (rich text)">HTML</mat-checkbox>
            <button *ngIf="editing" mat-icon-button matTooltip="Attach files" id="attachDesktop" (click)="attachFilesClicked()">
                <mat-icon svgIcon="attachment" style="transform: rotate(90deg)"></mat-icon>
            </button>
            <button *ngIf="editing" [disabled]="saved" mat-icon-button id="saveDraft" (click)="submit()">
                <mat-icon *ngIf="saved" svgIcon="cloud-check" matTooltip="Draft saved"></mat-icon>
                <mat-icon *ngIf="!saved && !saveErrorMessage" svgIcon="content-save" matTooltip="Save draft"></mat-icon>
                <mat-icon *ngIf="!saved && saveErrorMessage" color="warn" [matTooltip]="saveErrorMessage" svgIcon="content-save-alert"></mat-icon>
            </button>
            <button *ngIf="!isUnsaved" mat-icon-button matTooltip="Move draft to Trash" id="trashDraft" (click)="trashDraft()">
                <mat-icon svgIcon="delete"></mat-icon>
            </button>
            <button *ngIf="editing" mat-icon-button matTooltip="Close draft" id="closeDraft" (click)="close()">
                <mat-icon svgIcon="close"></mat-icon>
            </button>
            <button *ngIf="editing && isUnsaved" mat-icon-button matTooltip="Cancel draft" id="cancelDraft" (click)="cancelDraft()">
                <mat-icon svgIcon="delete"></mat-icon>
            </button>
            <button *ngIf="!editing" mat-icon-button (click)="editDraft()" matTooltip="Edit draft" id="editDraftIcon">
                <mat-icon svgIcon="pencil"></mat-icon>
            </button>
            <button *ngIf="editing" mat-icon-button matTooltip="Save as template" (click)="saveTemplate(true)" id="saveTemplate">
                <mat-icon svgIcon="file-document"></mat-icon>
            </button>
            <button *ngIf="editing" mat-icon-button matTooltip="Send mail" (click)="submit(true)" id="sendMail">
                <mat-icon svgIcon="send"></mat-icon>
            </button>
        </div>
    </mat-card-actions>
    <mat-card-subtitle>
        <mat-form-field floatPlaceholder="always" *ngIf="editing" style="width: 100%" id="fieldFrom">
            <mat-select placeholder="From" formControlName="from">
                <mat-option *ngFor="let from of draftDeskservice.fromsSubject.value" [value]="from.nameAndAddress">
                    {{from.nameAndAddress}}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <span *ngIf="!editing">
            <span *ngFor="let t of model.to">
                {{t.nameAndAddress}}
            </span>
        </span>
        <div class="fieldRecipient">
            <mailrecipient-input *ngIf="editing" style="flex-grow: 1"
                [initialfocus]="model.to.length === 0"
                placeholder="To"
                [recipients]="model.to"
                (updateRecipient)="onUpdateRecipient('to', $event)"
                (drop)="recipientDropped($event, 'to')"
                id="fieldTo"
            ></mailrecipient-input>
            <button mat-button *ngIf="editing && !hasCC"
                (click)="hasCC = true"
                (drop)="recipientDropped($event, 'cc')"
                id="buttonCC"
            > CC </button>
            <button mat-button *ngIf="editing && !hasBCC"
                (click)="hasBCC = true"
                (drop)="recipientDropped($event, 'bcc')"
                id="buttonBCC"
            > BCC </button>
        </div>
        <div class="recipientSuggestionContainer"
           [ngStyle]="{ 'display': showPopularRecipients ? 'block' : 'none' }"
           *ngIf="suggestedRecipients.length > 0 && editing"
        >
            <span>Recently used</span>
            <div class="recipientSuggestionList">
                <div *ngFor="let recipient of filteredSuggestions" class="suggestionItem">
                    <mat-chip
                        (click)="addRecipientFromSuggestions(recipient)"
                        draggable="true"
                        (dragstart)="recipientDragged($event, recipient)"
                    >
                        {{ recipient.nameAndAddress }}
                    </mat-chip>
                </div>
            </div>
        </div>
        <div style="display: flex;" *ngIf="editing && hasCC" class="fieldRecipient" (drop)="recipientDropped($event, 'cc')">
            <mailrecipient-input *ngIf="editing" style="width: auto; flex-grow: 1"
                placeholder="CC"
                [recipients]="model.cc"
                (updateRecipient)="onUpdateRecipient('cc', $event)"
            ></mailrecipient-input>
            <button mat-icon-button (click)="formGroup.controls.cc.setValue(null)"><mat-icon svgIcon="close"></mat-icon></button>
        </div>
        <div style="display: flex;" *ngIf="editing && hasBCC" class="fieldRecipient" (drop)="recipientDropped($event, 'bcc')">
            <mailrecipient-input *ngIf="editing" style="width: auto; flex-grow: 1"
                placeholder="BCC"
                [recipients]="model.bcc"
                (updateRecipient)="onUpdateRecipient('bcc', $event)"
            ></mailrecipient-input>
            <button mat-icon-button (click)="formGroup.controls.bcc.setValue(null)"><mat-icon svgIcon="close"></mat-icon></button>
        </div>
    </mat-card-subtitle>
    <mat-card-content>
        <mat-form-field *ngIf="editing" floatPlaceholder="auto" id="fieldSubject">
            <input matInput placeholder="Subject" name="subject" formControlName="subject" />
        </mat-form-field>
        <section *ngIf="editing" [ngClass]="{'dropzonehighlight': showDropZone, 'overdropzone': draggingOverDropZone}" (dragover)="draggingOverDropZone=true" (dragleave)="draggingOverDropZone=false" (drop)="dropFiles($event)" id="dropZone">
          <h1 *ngIf="showDropZone" id="dropZoneText">Drop files here</h1>
          <ng-container *ngIf="uploadProgress | async as uprogress">
            <mat-progress-bar *ngIf="uprogress > -1"
                mode="determinate"
                [value]="uprogress"
               >
            </mat-progress-bar>
            <button mat-button *ngIf="uprogress > -1" (click)="cancelAttachmentUpload()">
                <mat-icon svgIcon="close"></mat-icon> Cancel attachment upload
            </button>
            <mat-card-content *ngIf="uprogress > -1">
              <div *ngFor="let file of uploadingFiles">
                <p>{{file.name}}, {{formatBytes(file.size)}}</p>
              </div>
            </mat-card-content>
          </ng-container>
        </section>
        <section *ngIf="editing && model.attachments && model.attachments.length>0" id="attachments">
	  Attachments:&nbsp;
          <div class="attachment" *ngFor="let attachment of model.attachments; let i=index">
            <ng-container *ngIf="attachment.file_url!=='UTF-8Q'">
              <a [href]="'/rest/v1/email/'+model.mid+'/viewdraft/'+i+'/?filename='+attachment.file+'&origfilename='+displayWithoutRBWUL(attachment.file)">{{displayWithoutRBWUL(attachment.file)}} ({{attachment.sizeDisplay}})</a>
              <button mat-icon-button id="deleteAttachment" (click)="removeAttachment(i)"><mat-icon svgIcon="delete"></mat-icon></button>
            </ng-container>
          </div>
        </section>
        <span [hidden]="editing">
            {{this.model.preview}}
        </span>

        <div [hidden]="!editing">
            <div class="draft-buttons">
                <button *ngIf="editing" mat-icon-button matTooltip="Attach files" id="attachMobile" (click)="attachFilesClicked()">
                    <mat-icon svgIcon="attachment"></mat-icon>
                </button>
                <input #attachmentFileUploadInput type="file" [hidden]="true" multiple (change)="onFilesSelected($event)" />
            </div>
          <textarea style="
			   width: 100%;
			   height: 300px;
			   "
                    [id]="selector"
                    [hidden]="!formGroup.value.useHTML">
          </textarea>
          <mat-form-field id="messageTextArea" *ngIf="!formGroup.value.useHTML" floatPlaceholder="auto">
            <textarea
               #messageTextArea
               placeholder="Message text"
               matInput
               formControlName="msg_body"
               rows="20"
               >
            </textarea>
          </mat-form-field>
        </div>
    </mat-card-content>

</mat-card>
